import apiAsync from 'infrastructure/shared/api/api-async'

type ReloadTokenData = { token: string }

type ReloadTokenResponse = {
  success: boolean
  data: {
    token: string
    expiration_date: number
  }
}

export function postReloadToken(
  obj: ReloadTokenData,
  showLoading?: boolean
): Promise<ReloadTokenResponse> {
  return apiAsync.requestSync({
    endpoint: 'msAuth',
    path: 'reload-token',
    method: 'POST',
    obj: obj,
    showLoading: showLoading
  })
}

type ChangePasswordData = { new_password: string }

export function postChangeSelfPassword(
  data: ChangePasswordData,
  showLoading?: boolean
) {
  return apiAsync.requestSync({
    endpoint: 'msAuth',
    path: 'change-self-password',
    method: 'POST',
    obj: data,
    showLoading: showLoading
  })
}
